import { PointTransactionSource, PointTransactionType } from '@api/Customers/Customer';

export const getTransactionType = (type: PointTransactionType) => {
    switch (type) {
        case PointTransactionType.Earned:
            return 'Ganados';
        case PointTransactionType.Initial:
            return 'Iniciales';
        case PointTransactionType.Spent:
            return 'Canjeados';
    }
};

export const getTransactionColor = (type: PointTransactionType) => {
    switch (type) {
        case PointTransactionType.Earned:
            return 'success';
        case PointTransactionType.Initial:
            return 'success';
        case PointTransactionType.Spent:
            return 'error';
    }
};

export const getTransactionSign = (type: PointTransactionType) => {
    switch (type) {
        case PointTransactionType.Earned:
            return '+';
        case PointTransactionType.Initial:
            return '+';
        case PointTransactionType.Spent:
            return '-';
    }
};

export const getTransactionSource = (source: PointTransactionSource) => {
    switch (source) {
        case PointTransactionSource.QR:
            return 'Registro QR';
        case PointTransactionSource.Stamp:
            return 'Sellos';
        case PointTransactionSource.Manual:
            return 'Manual';
        case PointTransactionSource.Order:
            return 'Orden';
        case PointTransactionSource.Promotion:
            return 'Promotion';
        case PointTransactionSource.System:
            return 'System';
        case PointTransactionSource.GiftCard:
            return 'GiftCard';
        case PointTransactionSource.Warranty:
            return 'Garantias';
        case PointTransactionSource.Other:
            return 'Otro';
    }
};
